/**
 * Painel flutuante: valor da projeção de venda diária no gráfico de saldo.
 */

import React, { useEffect, useState } from 'react'
import { SlidersVertical, X } from 'lucide-react'
import './DailySalesProjectionPanel.css'

function formatCurrency(value) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: 0
  }).format(value || 0)
}

function parseAmount(value) {
  const parsed = parseFloat(String(value).replace(/\./g, '').replace(',', '.'))
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0
}

const DailySalesProjectionPanel = ({
  dailyAmount,
  onDailyAmountChange
}) => {
  const [open, setOpen] = useState(false)
  const [draft, setDraft] = useState(String(dailyAmount ?? ''))

  useEffect(() => {
    if (!open) {
      setDraft(String(dailyAmount ?? ''))
    }
  }, [dailyAmount, open])

  const amountNum = parseAmount(dailyAmount)
  const hasValue = amountNum > 0

  const applyDraft = () => {
    const next = parseAmount(draft)
    onDailyAmountChange(String(next))
    setOpen(false)
  }

  return (
    <div className="sales-projection-root">
      <button
        type="button"
        className={`sales-projection-fab ${hasValue ? 'has-value' : ''}`}
        onClick={() => setOpen((v) => !v)}
        title="Configurar projeção de entradas"
        aria-expanded={open}
        aria-label="Projeção de entradas"
      >
        <SlidersVertical size={18} />
      </button>

      {open && (
        <div className="sales-projection-panel" role="dialog" aria-label="Projeção de entradas">
          <div className="sales-projection-panel-header">
            <div>
              <h4 className="sales-projection-panel-title">
                Projeção de <span className="sales-projection-panel-accent">Entradas</span>
              </h4>
              <p className="sales-projection-panel-subtitle">
                Valor por dia útil (domingos são ignorados nos dias futuros)
              </p>
            </div>
            <button
              type="button"
              className="sales-projection-panel-close"
              onClick={() => setOpen(false)}
              aria-label="Fechar"
            >
              <X size={18} />
            </button>
          </div>

          <div className="sales-projection-panel-body">
            <label className="sales-projection-field" htmlFor="sales-projection-amount">
              Valor por dia
            </label>
            <input
              id="sales-projection-amount"
              type="number"
              min="0"
              step="0.01"
              className="sales-projection-input"
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') applyDraft()
              }}
            />
            <button type="button" className="sales-projection-apply" onClick={applyDraft}>
              Aplicar
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export { formatCurrency as formatSalesProjectionCurrency, parseAmount as parseSalesProjectionAmount }
export default DailySalesProjectionPanel
